
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/event/testseries/[testSeriesKey]",
      function () {
        return require("private-next-pages/event/testseries/[testSeriesKey].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/event/testseries/[testSeriesKey]"])
      });
    }
  